import React, { FunctionComponent } from 'react';

import { SummaryInformationCard } from 'src/components/summary-information-card';
import { SummaryInformationRow } from 'src/components/summary-information-row';
import { useCustomerInfoQueryStateOrThrow } from 'src/hooks/use-customer-info-query';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';
import { OrderInformationUtils } from 'src/utils/order-information-utils';

const PaymentInformation: FunctionComponent = () => {
  const serviceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);
  const {
    userInfo: { userDetails },
  } = useCustomerInfoQueryStateOrThrow();

  return (
    <SummaryInformationCard
      title={i18n.page.summary.paymentInformation.header}
      content={
        <div>
          <SummaryInformationRow
            label={i18n.page.summary.paymentInformation.payee}
            value={OrderInformationUtils.getFullName(userDetails)}
            isValueSensitive={true}
          />
          <SummaryInformationRow
            label={i18n.page.summary.paymentInformation.billingAddress}
            value={OrderInformationUtils.getShortAddress(serviceLocation)}
            isValueSensitive={true}
          />
          <SummaryInformationRow
            label={i18n.page.summary.paymentInformation.method}
            value={i18n.page.summary.paymentInformation.chosenMethod}
            note={{ label: i18n.page.summary.paymentInformation.note }}
          />
        </div>
      }
    />
  );
};

export { PaymentInformation };
